import { createContext } from "react";
const SocialMediaContext = createContext({});
export default SocialMediaContext;
